"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collapse = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var CollapsePanel_1 = require("./CollapsePanel");
var CollapseContext_1 = require("./CollapseContext");
var use_default_1 = require("../_util/use-default");
var config_context_1 = require("../_util/config-context");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
exports.Collapse = forward_ref_with_statics_1.forwardRefWithStatics(function Collapse(_a, ref) {
    var accordion = _a.accordion, activeIds = _a.activeIds, _b = _a.defaultActiveIds, defaultActiveIds = _b === void 0 ? [] : _b, onActive = _a.onActive, icon = _a.icon, _c = _a.iconPosition, iconPosition = _c === void 0 ? "left" : _c, destroyInactivePanel = _a.destroyInactivePanel, children = _a.children, className = _a.className, props = tslib_1.__rest(_a, ["accordion", "activeIds", "defaultActiveIds", "onActive", "icon", "iconPosition", "destroyInactivePanel", "children", "className"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    var _d = tslib_1.__read(use_default_1.useDefault(activeIds, defaultActiveIds, onActive), 2), value = _d[0], onChange = _d[1];
    var handleChange = function (activeIds, _a) {
        var event = _a.event, activeId = _a.activeId, active = _a.active;
        if (!accordion) {
            onChange(activeIds, { event: event, activeId: activeId, active: active });
        }
        else {
            onChange(active ? [activeId] : [], { event: event, activeId: activeId, active: active });
        }
    };
    return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-accordion-group", className) }, props),
        react_1.default.createElement(CollapseContext_1.CollapseContext.Provider, { value: {
                activeIds: value,
                onActive: handleChange,
                icon: icon,
                iconPosition: iconPosition,
                destroyInactivePanel: destroyInactivePanel,
            } }, children)));
}, {
    Panel: CollapsePanel_1.CollapsePanel,
});
exports.Collapse.displayName = "Collapse";
//# sourceMappingURL=Collapse.js.map